import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, MenuItem } from "@mui/material";

interface Option {
  value: string;
  label: string;
}

interface ReportDropdownProps {
  options: Option[];
  placeholder?: string;
  value?: string;
  onChange: (selected: Option | null) => void;
}

function MultiReportDropdown({
  options,
  placeholder = "Select an option",
  value = "",
  onChange,
}: ReportDropdownProps) {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value as string;
    const selectedOption = options.find(
      (opt) => opt.value.toLowerCase() === selectedValue.toLowerCase()
    ) || null;
    onChange(selectedOption);
  };

  return (
    <div>
      <FormControl
        sx={{
          //  minWidth: 352,
          // width: "352px",
          color: "#DEDEDE",
          background: "#fff !important",
          height: "56px",
          padding: "14px 0",
          borderRadius: "8px",
          fontWeight: "500",
          border: "1px solid rgb(212 212 212)",
          justifyContent: "center",
          backgroundColor: "#FFF"
        }}
      >
        <Select
          sx={{
            height: "56px",
            color: "rgba(40, 40, 41, 1)",
            fontSize: "16px",
            fontWeight: "400",
            borderRadius: "4px",
            width: "345px",
            background: "#fff !important",
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "4px",
              border: "none",
            },
            "& .MuiSelect-icon": {
              borderRadius: "4px",
              fontSize: "30px",
              color: "var(--Icon-Colour, #5E5E5E)",
            },
            "& .MuiSelect-select": {
              borderRadius: "4px",
              padding: "4px 15px",
            },
            "@media (max-width: 1366px)": {
              width: "250px",
            },
            "@media (max-width: 1280px)": {
              width: "250px",
            }
          }}
          value={value}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) return placeholder;
            const selectedOption = options.find(
              (opt) => opt.value.toLowerCase() === selected.toLowerCase()
            );
            return selectedOption ? selectedOption.label : placeholder;
          }}
          inputProps={{ "aria-label": "Without label" }}
          IconComponent={ExpandMoreIcon}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default MultiReportDropdown;